import {ConfirmationDialog} from '@ui/molecules/confirmation-dialog';
import React from 'react';
import {useStoreContext} from '@store/store-context';

export const DeleteGoal = ({handleContinue}: {handleContinue: () => void}) => {
  const {goalsState} = useStoreContext();
  const closeModal = () => goalsState.setDeleteModal('', false, '', '', []);

  const handleDelete = () => {
    handleContinue();
    closeModal();
  };

  return (
    <ConfirmationDialog
      open
      title={`Delete ${goalsState.goalFramework}?`}
      confirmLabel={`Delete ${goalsState.goalFramework}`}
      onCancel={closeModal}
      onConfirm={handleDelete}>
      Deleting <strong>{goalsState.deleteName}</strong> cannot be undone.
    </ConfirmationDialog>
  );
};
